import React from 'react';
import {Table,Button,Divider,Select,message} from 'antd';
import {createUuid} from '../../../utils/NHCore';
import NHFetch from '../../../utils/NHFetch';
import NHSelect from "../../common/NHSelect";
const Option = Select.Option;
const baseUrl = "/fwwgl/zzbd/";
const lcglHjxxUrl = "/proData/selectDataList?&sign=zhxg_yxxt_lcgl_hjxx";

export default class QztjpzForm extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            ylhjData:[],
            ylhjOptions:[],
            ylhjKeys:[],
            ylhjMap:{},
            currentPage:1
        }
    }
    componentDidMount(){
        this.getLcglHjxxData();
        this.getYlhjData();
    }
    getLcglHjxxData = ()=>{   //下拉数据为流程管理—环节管理”中的环节信息
        let initFormData = this.props.initFormData;
        NHFetch(lcglHjxxUrl, 'GET').then(res=>{    
            let ylhjOptions = [];
            let ylhjMap = {};      
            if(res && res.data){
                for(let obj of res.data){
                    ylhjOptions.push(<Option key={obj.VALUE} value={obj.VALUE}>{obj.LABEL}</Option>);
                    ylhjMap[obj.VALUE] = `${obj.LABEL}`;
                }
            }
            this.setState({ylhjOptions,ylhjMap});
        })
    }
    
    getYlhjData = ()=>{    
        let initFormData = this.props.initFormData;
        let sign = 'QZTJ_SIGN';
        NHFetch(baseUrl + sign + '/getYlhjData', 'GET').then(res=>{
            let ylhjData = [];
           
            if(res && res.data){
                ylhjData = res.data;              
            }
            this.setState({ylhjData});
        })
    }
    
    //验证
    validateFields = (func)=>{
        let initFormData = this.props.initFormData;
        let err = false;
        let ylhjData = this.state.ylhjData;
        func(err,ylhjData);
    }
   
    handleYlywxChange = (value,index)=>{
        let pageIndex = index + (this.state.currentPage - 1) * 10;
        let ylhjData = this.state.ylhjData;
        let {zzbdhjid} = ylhjData[pageIndex];
        let newData = ylhjData.filter(record => (value.includes(record.zzbdhjid) 
        && record.ylhjids.includes(zzbdhjid)));
        if((newData && newData.length>0)||value.includes(zzbdhjid)){
            message.warning("不能设置成死循环。");
        }else{
            ylhjData[pageIndex].ylhjids = value;
            this.setState({ylhjData});
        }
        // ylhjData[index].ylhjids = value;
        // this.setState({ylhjData});
    }

    tableOnChange=(pagination)=>{
        this.setState({currentPage : pagination.current});
    }
    render(){
        let {ylhjData,ylhjOptions,ylhjMap} = this.state;

        let columns = [
            {
                title: '序号',
                key: 'pxh',
                dataIndex: 'pxh',
                width: '60px',
                render: (text, record, index) => {
                    return <span>{index+1}</span>
                }
            }, {
                title: '自助报到名称',
                key: 'zzbdhjmc',
                dataIndex: 'zzbdhjmc',
                width: '400px',
            }, {
                title: '配置前置环节（迎新现场环节）',
                key: 'ylhjids',
                dataIndex: 'ylhjids',
                width: '500px',
                render: (text, record, index) => {
                    let {ylhjids} = record;
                    return (                       
                        <Select mode="multiple" value={ylhjids} style={{minWidth:'500px'}}
                            onChange={(value)=>{this.handleYlywxChange(value,index);}}>
                                {ylhjOptions}
                        </Select>                                      
                    );
                }
            }            
        ]
        return <div>
            <Table dataSource={ylhjData} columns={columns} onChange={(pagination)=>{this.tableOnChange(pagination)}} rowKey={record=>record.pkid} pagination={true} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./components/fwwgl/zzbd/QztjpzForm.js